exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Ky49 {\n  width: 100%;\n  height: calc(100% - 53px);\n}\nh3._2p8qr {\n  font-family: \"Montserrat\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\nh3._2p8qr small {\n  font-weight: normal;\n  font-size: 70%;\n}\n", ""]);

// Exports
exports.locals = {
	"pdf": "_2Ky49",
	"title": "_2p8qr"
};